import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "./store";

// Selector base
const selectUtils = (state: RootState) => state.utils;

// Selector memoizado
export const selectShow = createSelector(
  [selectUtils],
  (utils) => utils.show
);
